// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  playerId: __t.string().primaryKey(),
  identity: __t.identity(),
  lobbyId: __t.string(),
  isBot: __t.bool(),
  name: __t.string(),
  color: __t.string(),
  posX: __t.i32(),
  posY: __t.i32(),
  velX: __t.i32(),
  velY: __t.i32(),
  rotation: __t.f32(),
  targetRotation: __t.f32(),
  angularVelocity: __t.f32(),
  health: __t.f32(),
  maxHealth: __t.f32(),
  kills: __t.u16(),
  deaths: __t.u16(),
  pelletsCollected: __t.u32(),
  scale: __t.f32(),
  damageMultiplier: __t.f32(),
  speedMultiplier: __t.f32(),
  lastAcknowledgedSequence: __t.u32(),
  lastShotSequence: __t.u32(),
  totalKills: __t.u32(),
  totalDeaths: __t.u32(),
  totalPelletsCollected: __t.u32(),
  captures: __t.u16(),
  lastMineDeployAt: __t.u32(),
  lastBoostAt: __t.u32(),
  teamId: __t.i32(),
  primaryWeapon: __t.string(),
  debugInvincible: __t.bool(),
  isDead: __t.bool(),
  deathSequence: __t.u32(),
  connectedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
